import { Button, Logo } from "@src/components/elements";
import { Page } from "@src/shared/pages";
import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    color: var(--dark-gray);
    font-size: 3rem;
  }
`;

export const NotFound: React.FC = () => {
  return (
    <StyledRoot className="pad">
      <div className="warning-container">
        <Logo />

        <h1>Not found</h1>
        <h3>The page you were looking for could not be found.</h3>
        <div>
          <a href={Page.HOME}>
            <Button variant="primary" size="medium">
              Back to Home
            </Button>
          </a>
        </div>
      </div>
    </StyledRoot>
  );
};
